export default {
    bootstrap() {
        global.googletag = global.googletag || {};
        global.googletag.cmd = global.googletag.cmd || [];
    },
};
